export default __webpack_public_path__ + "static/media/kite-active.62a89c8f.svg";